import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Spin,
  Col,
  InputNumber,
  Divider,
  Space,
  Button,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
// import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "./interestRate.config";
import styles from "../../../assets/styles/styles";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const EditInterestRate = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const { newInterestRateItems } = staticConfig;
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [interestRateDetail, setInterestRateDetail] = useState({});
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
  }, []);

  function onCancel() {
    navigate("/prd0605", { replace: false });
  }
  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.Floatingrates}/${state.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setInterestRateDetail(objDetail);
        setIsLoading(false);

        setInputField([
          {
            name: labelConfig.floatingRateId,
            value: objDetail.id,
          },
          {
            name: labelConfig.floatingRateName,
            value: objDetail.name,
          },
          {
            name: labelConfig.isBaseLendingRate,
            value: objDetail.isBaseLendingRate ? "Yes" : "No",
          },
          {
            name: labelConfig.status,
            value: objDetail.isActive ? "Active" : "Inactive",
          },
        ]);
        setIsLoading(false);
      }
    });
  };
  const onSubmit = (formValues) => {
    const url = `${apiConfig.Floatingrates}/${state.id}`;
    let tempPeriod = [];
    formValues?.ratePeriods?.forEach((element) => {
      tempPeriod.push({
        ...element,
        fromDate: BOM.DateTime(element.fromDate, "only-date"),
        dateFormat: "dd MMMM yyyy",
        locale: "en",
      });
    });

    formValues.ratePeriods = tempPeriod;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newFloatingRateMsg);
        navigate("/interest-rate-detail", { state: { id: res.resourceId } });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.editFloatingRate}
        pageItems={staticConfig.editFloatingRateItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.floatingRateSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.generalInfo}
              </Divider>
              {inputField.map((item, index) => (
                <Col span={6} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={item.value}
                    />
                  </Form.Item>
                </Col>
              ))}
            </Row>
            <Row>
              <Divider orientation="left" orientationMargin="0">
                {labelConfig.floatingRatePeriodInfo}
              </Divider>
            </Row>
            {interestRateDetail?.ratePeriods?.map((item, index) => (
              <Row key={index}>
                <Col span={6} style={{ padding: "0px 8px" }}>
                  <Form.Item label={<Text strong>{labelConfig.fromDate}</Text>}>
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={BOM.FormatArrayDate(item.fromDate)}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{labelConfig.floatingRate}</Text>}
                  >
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={item.interestRate}
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={<Text strong>{labelConfig.isDifferential}</Text>}
                  >
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      value={
                        item.isDifferentialToBaseLendingRate ? "Yes" : "No"
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            ))}
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.List name="ratePeriods">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{
                            display: "flex",
                            marginBottom: 8,
                          }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "fromDate"]}
                            rules={[
                              {
                                required: true,
                                message: BOM.CheckReqFld(labelConfig.fromDate),
                              },
                            ]}
                          >
                            <DatePicker
                              style={{ width: "100%", height: 35 }}
                              className="bond-date-picker"
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "interestRate"]}
                            rules={[
                              {
                                required: true,
                                message: BOM.CheckReqFld(
                                  labelConfig.floatingRate
                                ),
                              },
                            ]}
                          >
                            <InputNumber
                              placeholder={labelConfig.floatingRate}
                              style={styles.ofInputFieldNumber}
                            />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "isDifferentialToBaseLendingRate"]}
                          >
                            <Select
                              defaultValue={staticConfig.yesOrNoData[1].value}
                              placeholder={labelConfig.isDifferential}
                              options={staticConfig.yesOrNoData}
                              showSearch
                            />
                          </Form.Item>
                          <CloseCircleFilled
                            style={{
                              color: "#92428B",
                              fontSize: "25px",
                              fontWeight: "bolder",
                            }}
                            onClick={() => remove(name)}
                          />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                          style={{
                            backgroundColor: "#15CCAE",
                            color: "white",
                            minWidth: "120px",
                            maxWidth: "100%",
                            width: "auto",
                            padding: "0 16px",
                            height: "auto",
                            minHeight: "32px",
                            marginBottom: 20,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "clamp(12px, 2.5vw, 14px)",
                            lineHeight: "1.2",
                          }}
                          className="responsive-button"
                        >
                          <span
                            style={{
                              display: "inline-block",
                              maxWidth: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {labelConfig.addFloatingPeriod}
                          </span>
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_FLOATINGRATE") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditInterestRate);
